module.exports = __webpack_public_path__ + "static/media/8900_Entry.1ef36322.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_Entry.jpg
// module id = 573
// module chunks = 0